package com.arena_web.data.repository

import com.arena_web.data.api.NotificationApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.NotificationRepository

class NotificationRepositoryImpl(private val notificationApi: NotificationApi) : NotificationRepository {

    override suspend fun getNotifications(params: Map<String, String>): Result<NotificationsPageDto> =
        apiCall { notificationApi.getNotifications(params) }

    override suspend fun markAsRead(notificationId: String): Result<Unit> =
        apiCallUnit { notificationApi.markAsRead(notificationId) }

    override suspend fun markAllAsRead(): Result<Unit> =
        apiCallUnit { notificationApi.markAllAsRead() }
}
